import React, { useCallback, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const CustomMenu = ({ MenuProps, children, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleButtonClick = useCallback((event) => {
    if (anchorEl) setAnchorEl(null);
    else setAnchorEl(event.currentTarget);
  }, [anchorEl]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (onClick) => (...args) => {
    if (onClick) onClick(...args);
    handleClose();
  };

  return (
    <>
      {children({ handleButtonClick, open })}

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        keepMounted
        {...(MenuProps || {})}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            disabled={option.disabled}
            onClick={handleOptionClick(option.onClick)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CustomMenu;